import { Slot } from '@radix-ui/react-slot'
import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, JSX } from 'react'

export interface DialogHeaderProps extends ComponentPropsWithoutRef<'div'> {
  asChild?: boolean
}

export function DialogHeader({
  asChild,
  className,
  ...delegated
}: DialogHeaderProps): JSX.Element {
  const Comp = asChild ? Slot : 'div'
  return (
    <Comp
      className={cn(
        'sticky top-0 z-50 flex gap-2 bg-background/95 p-6 backdrop-blur-sm supports-backdrop-filter:bg-background/60',
        className
      )}
      {...delegated}
    />
  )
}
